import axios from 'apiclient';

const sendAnswer = (load) => axios.post('/api/sendRegistration', {
  ...load,
  mandant: process.env.CLIENTNAME,
}).then((res) => res);
export default sendAnswer;
